/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

.add-event-dialog {
  .MuiPaper-root {
    width: 720px;
    height: 240px;
  }

  .title {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }

  .time-field {
    width: 25%;
  }

  .event-name-select {
    width: 75%;
  }

  .add-event-dialog-confirmed {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    .check-circle {
      width: 52px;
      height: 52px;
    }
  }

  .event-select .MuiSelect-select {
    display: grid;
    grid-template-columns: 28px 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: 'icon name';

    .icon {
      grid-area: icon;

      .icon-svg {
        width: 16px;
        height: 16px;
        margin-right: variables.$margin-medium;
      }
    }

    .name {
      grid-area: name;
    }

    .explanation {
      visibility: hidden;
      width: 0;
      height: 0;
    }
  }
}

.add-event-menu-item {
  display: grid;
  grid-template-columns: 28px auto;
  grid-template-rows: auto auto;
  grid-template-areas:
    'icon name'
    'icon explanation';

  .icon {
    grid-area: icon;
    line-height: 0;

    .icon-svg {
      width: 16px;
      height: 16px;
      margin-right: variables.$margin-medium;
    }
  }

  .name {
    grid-area: name;
  }

  .explanation {
    grid-area: explanation;
    color: variables.$color-black-60;
    font-size: 14px;
    max-width: 345px;
    text-wrap: auto;
  }
}
